export const PATHS = {
  // Home Page
  // Since the admin portal does not have a home page url the below is treated as such.
  DEFAULT_URL: "/", 
  // Admin Redirects
  // The extra url of "/admin" is needed in order for the sidemenu to be highlighted correctly. And to keep consistency in the paths route configuration.
  ADMIN: "/admin",
  // Users
  ADMIN_USERS: "/admin/users",
  ADMIN_USERS_ADD_USER: "/admin/users/add-user",
  ADMIN_USERS_USER: "/admin/users/:id",
  ADMIN_USERS_USER_PROFILE: "/admin/users/:id/user-profile",
  // Add Tenant(s) to User(s) ( from User Profile)
  ADMIN_USERS_ADD_TENANT_TO_USER: "/admin/users/:id/user-profile/add-tenant",
  // Edit Tenant(s) of User(s) ( from User Profile)
  ADMIN_USERS_EDIT_TENANT_OF_USER: "/admin/users/:id/user-profile/:tenantId",
  // Tenants
  ADMIN_TENANTS_LANDING: "/admin/tenants",
  ADMIN_TENANTS_ADD_TENANT: "/admin/tenants/add-tenant",
  ADMIN_TENANTS_TENANT_DETAILS: "/admin/tenants/:id/details",
  ADMIN_TENANTS_ID_SYNC_SKILLS: "/admin/tenants/:id/sync-skills",
  // Execution Flows
  ADMIN_EXECUTION_FLOW_LANDING: "/admin/execution-flow",
  ADMIN_EXECUTION_FLOW_ADD: "/admin/execution-flow/add",
};
